import { createTheme } from '@mui/material/styles';

// 管理画面デザインハーネスと同じ色・文字・操作部品の基準。
export const dashboardTheme = createTheme({
  palette: {
    primary: { main: '#272522', contrastText: '#fff' },
    secondary: { main: '#9f545c', contrastText: '#fff' },
    success: { main: '#376a53' },
    info: { main: '#80624e' },
    warning: { main: '#906232' },
    error: { main: '#aa414b' },
    background: { default: '#f7f6f3', paper: '#fff' },
    text: { primary: '#272522', secondary: '#77716d' },
    divider: '#dedbd7',
  },
  typography: {
    fontFamily: '-apple-system, BlinkMacSystemFont, "Helvetica Neue", "Hiragino Kaku Gothic ProN", "Hiragino Sans", "Noto Sans JP", Meiryo, sans-serif',
    h4: { fontSize: 24, fontWeight: 700, lineHeight: 1.35 },
    h5: { fontSize: 18, fontWeight: 700, lineHeight: 1.4 },
    h6: { fontSize: 16, fontWeight: 700, lineHeight: 1.45 },
    body1: { fontSize: 13, lineHeight: 1.6 },
    body2: { fontSize: 12, lineHeight: 1.6 },
    subtitle1: { fontSize: 13, lineHeight: 1.5, fontWeight: 700 },
    subtitle2: { fontSize: 12, lineHeight: 1.5, fontWeight: 700 },
    caption: { fontSize: 11, lineHeight: 1.5 },
    button: { fontSize: 13, fontWeight: 600, textTransform: 'none' },
  },
  shape: { borderRadius: 12 },
  components: {
    MuiButton: { styleOverrides: { root: { minHeight: 34, borderRadius: 9, boxShadow: 'none', padding: '6px 12px', '&:hover': { boxShadow: 'none' } }, outlined: { borderColor: '#dedbd7', color: '#272522' } } },
    MuiPaper: { styleOverrides: { root: { backgroundImage: 'none' }, outlined: { borderColor: '#dedbd7', boxShadow: '0 1px 2px #2725220a' } } },
    MuiTextField: { styleOverrides: { root: { '& .MuiOutlinedInput-root': { borderRadius: 8, backgroundColor: '#fff' } } } },
    MuiOutlinedInput: { styleOverrides: { notchedOutline: { borderColor: '#cfcac6' } } },
    MuiDialog: { styleOverrides: { paper: { borderRadius: 14 } } },
    MuiDrawer: { styleOverrides: { paper: { backgroundImage: 'none' } } },
    MuiToggleButton: { styleOverrides: { root: { textTransform: 'none', borderColor: '#dedbd7', fontSize: 12 } } },
  },
});
